import AppDrawer from "components/Drawers/AppDrawer";
import { Alert, Button, Input } from "reactstrap";
import Constants from "utils/Constants";
import IconCard from "./IconCard";

const WorkflowDrawer = ({ open, onClose, workflow, setWorkflow, error }) => {
  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      headerTitle="Workflow Basics"
      headerDescription="Get started by entering basic information about your workflow"
      headerOptions={
        <Button
          onClick={onClose}
          disabled={!workflow?.Name || !workflow?.Trigger}
          color="primary"
          size="sm"
        >
          Done
        </Button>
      }
      bodyCSS="p-3"
      body={
        <>
          {error && (
            <Alert size="sm" color="danger">
              {error}
            </Alert>
          )}
          <h4 className="m1-0">Name</h4>
          <Input
            placeholder="Workflow Name"
            value={workflow?.Name ?? ""}
            onChange={(e) =>
              setWorkflow((prev) => ({ ...prev, Name: e.target.value }))
            }
          />
          <h4 className="mb-1 mt-4">Description</h4>
          <Input
            placeholder="Workflow Description"
            value={workflow?.Description ?? ""}
            onChange={(e) =>
              setWorkflow((prev) => ({ ...prev, Description: e.target.value }))
            }
          />
          <hr />
          <div className=" mt-3 mb-3">
            <h4 className="mb-0">Initial Trigger</h4>
            <small className="mb-2">What will initiate this workflow?</small>
          </div>
          {Object.keys(Constants.WORKFLOW_TRIGGERS).map((key, i) => {
            const trigger = Constants.WORKFLOW_TRIGGERS[key];
            const isSelected = workflow?.Trigger?.Type === trigger?.Type;

            return (
              <IconCard
                key={key}
                icon={trigger.Icon}
                name={trigger.Name}
                description={trigger.Description}
                isSelected={isSelected}
                onClick={() =>
                  setWorkflow((prev) => ({
                    ...prev,
                    Trigger: isSelected ? null : trigger,
                  }))
                }
              />
            );
          })}
        </>
      }
    />
  );
};

export default WorkflowDrawer;
